


























































































































































































































































































































































































































import { Component, Mixins, Prop, Vue, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import HydrationGuard from "@/mixins/HydrationGuard";
import PemantauanTerapiGiziSvc from "@/services/PemantauanTerapiGizi";
import Adime from "@/services/Adime";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { userModule } from "@/store/modules/user";
import { localISODate } from "@/utils/localDate";
import {
  AMBANG_ASUPAN_ADEKUAT,
  METODE_SKRINING_GIZI,
  RUTE_PEMBERIAN_GIZI,
  STATUS_GIZI_ANAK,
  STATUS_GIZI_DEWASA
} from "@/constants/gizi";
import {
  PemantauanTerapiGizi,
  PemantauanTerapiGiziHeaderRequest,
  PemantauanTerapiGiziItem,
  PemantauanTerapiGiziItemRequest
} from "@/types/pemantauan_terapi_gizi";

const FORM_CODE = "pemantauan_terapi_gizi";

const HEADER_KEYS: Array<keyof PemantauanTerapiGiziHeaderRequest> = [
  "diagnosa_medis",
  "tgl_masuk",
  "ruang_unit",
  "dpjp_nama",
  "status_gizi_masuk",
  "metode_skrining",
  "evaluasi_asupan",
  "perubahan_berat_badan",
  "laboratorium_pendukung",
  "kesimpulan"
];

function defaultHeader(): PemantauanTerapiGiziHeaderRequest {
  return {
    diagnosa_medis: null,
    tgl_masuk: null,
    ruang_unit: null,
    dpjp_nama: null,
    status_gizi_masuk: null,
    metode_skrining: null,
    evaluasi_asupan: null,
    perubahan_berat_badan: null,
    laboratorium_pendukung: null,
    kesimpulan: null
  };
}

function defaultItem(): PemantauanTerapiGiziItemRequest {
  return {
    tanggal: localISODate(),
    jenis_diet: null,
    rute: null,
    target_energi: null,
    target_protein: null,
    asupan_energi: null,
    asupan_protein: null
  };
}

function toNumberOrNull(v: unknown): number | null {
  if (v === null || v === undefined || v === "") return null;
  const n = Number(v);

  return isNaN(n) ? null : n;
}

function normaliseText(v: unknown): string {
  return v === null || v === undefined ? "" : String(v);
}

@Component({
  components: { CardModalTtd },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class PemantauanTerapiGiziPage extends Mixins(HydrationGuard) {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ type: Boolean, default: false }) readonly isActive!: boolean;
  isReadOnly!: () => boolean;

  doc: PemantauanTerapiGizi | null = null;
  header: PemantauanTerapiGiziHeaderRequest = defaultHeader();

  loading = false;
  creating = false;
  savingHeader = false;

  itemDialog = false;
  itemValid = false;
  editingItemId: number | null = null;
  itemForm: PemantauanTerapiGiziItemRequest = defaultItem();
  savingItem = false;
  deletingId: number | null = null;
  loadingAdime = false;

  modalTtd = false;
  verifying = false;

  requestSeq = 0;

  ambangAdekuat = AMBANG_ASUPAN_ADEKUAT;
  ruteOptions = RUTE_PEMBERIAN_GIZI;
  metodeSkriningOptions = METODE_SKRINING_GIZI;
  statusGiziOptions = [...STATUS_GIZI_DEWASA, ...STATUS_GIZI_ANAK];
  today = localISODate();

  itemHeaders = [
    { text: "Tanggal", value: "tanggal", width: "110px" },
    { text: "Jenis Diet & Rute", value: "jenis_diet", sortable: false },
    { text: "Target Energi & Protein", value: "target", sortable: false },
    { text: "Asupan Akhir", value: "asupan", sortable: false },
    { text: "Petugas", value: "user_nama", sortable: false },
    { text: "", value: "actions", sortable: false, width: "90px" }
  ];

  rules = {
    required: (v: unknown) => (v !== null && v !== undefined && String(v).trim() !== "") || "Wajib diisi",
    nonNegative: (v: unknown) => v === null || v === "" || Number(v) >= 0 || "Tidak boleh negatif"
  };

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get userId(): number | null {
    return userModule.user?.id ?? null;
  }

  get isAhliGizi(): boolean {
    return userModule.user?.profesi === "Gizi";
  }

  get canFill(): boolean {
    return this.isAhliGizi || userModule.canAccessForm(FORM_CODE, "create");
  }

  get lockReason(): string {
    if (this.doc?.is_verified) return "Formulir sudah diverifikasi Ahli Gizi dan terkunci.";
    if (this.readOnly) return "Formulir terkunci: rekam medis terkunci sejak pasien pulang.";

    return "";
  }

  get canEditHeader(): boolean {
    return !this.lockReason && this.canFill && !this.busy;
  }

  get canEditEvaluasi(): boolean {
    return this.canEditHeader && this.isAhliGizi;
  }

  get createBlockReason(): string {
    if (this.readOnly) return "Tidak dapat membuat formulir: rekam medis terkunci sejak pasien pulang.";
    if (!this.canFill) return "Akun/unit login Anda tidak termasuk PPA Rawat Inap yang mengisi formulir ini.";

    return "";
  }

  get addItemBlockReason(): string {
    if (this.lockReason) return this.lockReason;
    if (!this.canFill) return "Akun/unit login Anda tidak termasuk PPA Rawat Inap yang mengisi formulir ini.";

    return "";
  }

  get headerDirty(): boolean {
    const doc = this.doc;
    if (!doc) return false;

    return HEADER_KEYS.some(key => normaliseText(this.header[key]) !== normaliseText(doc[key]));
  }

  get verifyBlockReason(): string {
    if (this.lockReason) return this.lockReason;
    if (!this.isAhliGizi) return "Verifikasi hanya dapat dilakukan oleh Ahli Gizi.";
    if (!this.doc || this.doc.items.length < 1) return "Tambahkan minimal satu baris pemantauan.";
    if (this.headerDirty) return "Simpan perubahan Identitas & Evaluasi terlebih dahulu.";
    if (!normaliseText(this.doc.kesimpulan).trim()) return "Isi dan simpan Kesimpulan terlebih dahulu.";

    return "";
  }

  get namaPasien(): string {
    return storePasien.identitasPasien?.nama || "-";
  }

  get noRm(): string {
    return storePasien.identitasPasien?.rm_dash || this.rm || "-";
  }

  mounted() {
    this.load();
  }

  @Watch("register")
  onRegisterChanged() {
    this.doc = null;
    this.header = defaultHeader();
    this.loaded = false;
    this.load();
  }

  itemBlockReason(item: PemantauanTerapiGiziItem): string {
    if (this.lockReason) return this.lockReason;
    if (!this.canFill) return "Akun/unit login Anda tidak termasuk PPA Rawat Inap yang mengisi formulir ini.";
    if (item.user_id !== this.userId && !this.isAhliGizi) {
      return "Baris hanya dapat diubah oleh petugas yang mencatatnya atau Ahli Gizi.";
    }

    return "";
  }

  async load() {
    if (!this.register) return;

    const seq = ++this.requestSeq;
    const register = this.register;
    this.loading = true;

    try {
      await this.hydrate(async () => {
        const doc = await PemantauanTerapiGiziSvc.getByRegister(register);
        if (seq !== this.requestSeq || register !== this.register) return;

        this.applyDoc(doc);
      });
    } finally {
      if (seq === this.requestSeq) this.loading = false;
    }
  }

  applyDoc(doc: PemantauanTerapiGizi | null, forceHeader = false) {
    const keepHeader = !forceHeader && this.headerDirty;
    this.doc = doc;

    if (!doc) {
      this.header = defaultHeader();
      return;
    }

    if (!keepHeader) {
      const header = defaultHeader();
      HEADER_KEYS.forEach(key => {
        header[key] = doc[key] as string | null;
      });
      this.header = header;
    }
  }

  async buatFormulir() {
    if (this.createBlockReason) return;

    this.creating = true;
    try {
      const doc = await PemantauanTerapiGiziSvc.create({
        register_id: this.register,
        pasien_rm: this.rm,
        unit_id: userModule.user?.unit_id ?? null
      });
      this.applyDoc(doc, true);
      appModule.NoticeDelay("Formulir Pemantauan Terapi Gizi dibuat");
    } finally {
      this.creating = false;
    }
  }

  async simpanHeader() {
    if (!this.doc || !this.canEditHeader) return;

    this.savingHeader = true;
    try {
      const payload = { ...this.header };
      if (!this.isAhliGizi) {
        payload.evaluasi_asupan = this.doc.evaluasi_asupan;
        payload.perubahan_berat_badan = this.doc.perubahan_berat_badan;
        payload.laboratorium_pendukung = this.doc.laboratorium_pendukung;
        payload.kesimpulan = this.doc.kesimpulan;
      }

      const doc = await PemantauanTerapiGiziSvc.update(this.doc.id, payload);
      this.applyDoc(doc, true);
      appModule.NoticeDelay("Pemantauan Terapi Gizi berhasil disimpan");
    } finally {
      this.savingHeader = false;
    }
  }

  bukaTambahBaris() {
    if (this.addItemBlockReason) return;

    this.editingItemId = null;
    this.itemForm = defaultItem();
    const last = this.doc && this.doc.items.length ? this.doc.items[this.doc.items.length - 1] : null;
    if (last) {
      this.itemForm.jenis_diet = last.jenis_diet;
      this.itemForm.rute = last.rute;
      this.itemForm.target_energi = last.target_energi;
      this.itemForm.target_protein = last.target_protein;
    }
    this.itemDialog = true;
    this.$nextTick(() => this.resetValidation());
  }

  bukaUbahBaris(item: PemantauanTerapiGiziItem) {
    if (this.itemBlockReason(item)) return;

    this.editingItemId = item.id;
    this.itemForm = {
      tanggal: item.tanggal,
      jenis_diet: item.jenis_diet,
      rute: item.rute,
      target_energi: item.target_energi,
      target_protein: item.target_protein,
      asupan_energi: item.asupan_energi,
      asupan_protein: item.asupan_protein
    };
    this.itemDialog = true;
  }

  tutupDialog() {
    this.itemDialog = false;
    this.editingItemId = null;
    this.itemForm = defaultItem();
  }

  resetValidation() {
    const form = this.$refs.itemFormRef as Vue & { resetValidation: () => void };
    if (form) form.resetValidation();
  }

  async ambilDariAdime() {
    this.loadingAdime = true;
    try {
      const resp = await Adime.getByRegister(this.register);
      const list = (resp && resp.data) || [];
      const terakhir = list
        .slice()
        .reverse()
        .find(a => {
          const d = a.detail;
          return !!d && !!(d.diet || d.rute || d.energi || d.protein);
        });

      if (!terakhir || !terakhir.detail) {
        appModule.NoticeDelayAlert("Belum ada ADIME berisi intervensi diet untuk kunjungan ini.");
        return;
      }

      const d = terakhir.detail;
      const jenisDiet = [d.diet, d.bentuk_makanan ? "bentuk " + d.bentuk_makanan : null, d.frekuensi_pemberian]
        .filter(Boolean)
        .join(", ");

      if (jenisDiet) this.itemForm.jenis_diet = jenisDiet;
      if (d.rute) this.itemForm.rute = d.rute;
      if (toNumberOrNull(d.energi) !== null) this.itemForm.target_energi = toNumberOrNull(d.energi);
      if (toNumberOrNull(d.protein) !== null) this.itemForm.target_protein = toNumberOrNull(d.protein);

      appModule.NoticeDelay("Diet & target diisi dari ADIME " + this.formatDateTime(terakhir.examined_at));
    } finally {
      this.loadingAdime = false;
    }
  }

  async simpanBaris() {
    if (!this.doc || !this.itemValid) return;

    const payload: PemantauanTerapiGiziItemRequest = {
      tanggal: this.itemForm.tanggal,
      jenis_diet: this.itemForm.jenis_diet,
      rute: this.itemForm.rute,
      target_energi: toNumberOrNull(this.itemForm.target_energi),
      target_protein: toNumberOrNull(this.itemForm.target_protein),
      asupan_energi: toNumberOrNull(this.itemForm.asupan_energi),
      asupan_protein: toNumberOrNull(this.itemForm.asupan_protein)
    };

    this.savingItem = true;
    try {
      const doc = this.editingItemId
        ? await PemantauanTerapiGiziSvc.updateItem(this.doc.id, this.editingItemId, payload)
        : await PemantauanTerapiGiziSvc.storeItem(this.doc.id, payload);
      this.applyDoc(doc);
      this.tutupDialog();
      appModule.NoticeDelay("Baris pemantauan berhasil disimpan");
    } finally {
      this.savingItem = false;
    }
  }

  async hapusBaris(item: PemantauanTerapiGiziItem) {
    if (!this.doc || this.itemBlockReason(item)) return;
    if (!confirm("Hapus baris pemantauan tanggal " + this.formatDate(item.tanggal) + "?")) return;

    this.deletingId = item.id;
    try {
      const doc = await PemantauanTerapiGiziSvc.deleteItem(this.doc.id, item.id);
      this.applyDoc(doc);
      appModule.NoticeDelay("Baris pemantauan berhasil dihapus");
    } finally {
      this.deletingId = null;
    }
  }

  bukaVerifikasi() {
    if (this.verifyBlockReason) return;

    appModule.addMsgTtd("");
    this.modalTtd = true;
  }

  async verifikasi(password: string) {
    if (!this.doc || this.verifying) return;

    this.verifying = true;
    try {
      const doc = await PemantauanTerapiGiziSvc.verify(this.doc.id, password);
      this.applyDoc(doc, true);
      this.modalTtd = false;
      appModule.NoticeDelay("Pemantauan Terapi Gizi berhasil diverifikasi");
    } catch (err) {
      const message = (err as { response?: { data?: { message?: string } } })?.response?.data?.message;
      appModule.addMsgTtd(message || "Verifikasi gagal");
    } finally {
      this.verifying = false;
    }
  }

  cetak() {
    if (this.doc) PemantauanTerapiGiziSvc.print(this.doc.id);
  }

  persenPreview(asupan: unknown, target: unknown): string {
    const a = toNumberOrNull(asupan);
    const t = toNumberOrNull(target);
    if (a === null || t === null || t <= 0) return "";

    return Math.round((a / t) * 100) + "% dari target";
  }

  warnaPersen(persen: number): string {
    return persen >= AMBANG_ASUPAN_ADEKUAT ? "success" : "orange darken-2";
  }

  formatAngka(v: number | null, satuan: string): string {
    if (v === null || v === undefined) return "-";

    return Number(v).toLocaleString("id-ID") + " " + satuan;
  }

  formatDate(v: string | null): string {
    if (!v) return "-";
    const [y, m, d] = v.slice(0, 10).split("-");

    return d && m && y ? `${d}-${m}-${y}` : v;
  }

  formatDateTime(v: string | null): string {
    if (!v) return "-";

    return this.formatDate(v) + (v.length > 10 ? " " + v.slice(11, 16) : "");
  }
}
